var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c(
              "div",
              { staticClass: "single container-max page-content" },
              [
                _c("div", { staticClass: "row position-relative" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-lg-7",
                      attrs: { id: "item-container" }
                    },
                    [_vm._t("image-carousel"), _vm._v(" "), _vm._m(0)],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-lg-5 single-rightside pt-5" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "stick-in-parent",
                              rawName: "v-stick-in-parent"
                            }
                          ],
                          attrs: { "data-sticky-container": "#item-container" }
                        },
                        [
                          _c(
                            "h1",
                            {
                              staticClass: "title",
                              attrs: { "data-testing": "item-name" }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("itemName")(_vm.currentVariation)
                                  ) +
                                  "\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isShortDescriptionActive &&
                          _vm.currentVariation.texts.shortDescription !== ""
                            ? _c("p", {
                                staticClass: "single-description",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.shortDescription
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-5 d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "articlenumber small text-muted"
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNumber"
                                          )
                                        ) +
                                        "\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.currentVariation.item.id) +
                                        "\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "d-block" }, [
                                    _c("b", [_vm._v("Lieferzeit: ")]),
                                    _vm._v(" "),
                                    new Date(
                                      _vm.currentVariation.variation.releasedAt
                                    ) > Date.now()
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "availability availability_5"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                             Jetzt vorbestellen!"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "Ab dem " +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    new Date(
                                                      _vm.currentVariation.variation.releasedAt
                                                    ),
                                                    "DD.MM.YYYY"
                                                  )
                                                ) +
                                                " wieder lieferbar.\n                                        "
                                            )
                                          ]
                                        )
                                      : _vm.currentVariation.variation
                                          .availability
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              "availability availability_" +
                                              _vm.currentVariation.variation
                                                .availability.id
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.availability
                                                      .names.name
                                                  ) +
                                                  "\n                                            "
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm._t("premium")
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.currentVariation.item.manufacturer.logo
                                ? _c(
                                    "div",
                                    { staticClass: "producer-img" },
                                    [_vm._t("manufacturer-url")],
                                    2
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.attributes.length || Object.keys(_vm.units).length
                            ? _c("div", [_c("variation-select")], 1)
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.filter.isSalable &&
                          _vm.variationGroupedProperties.length
                            ? _c("div", [_c("order-property-list")], 1)
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("before-price"),
                          _vm._v(" "),
                          _c("item-price", {
                            attrs: {
                              "show-cross-price": _vm.isRecommendedPriceActive
                            }
                          }),
                          _vm._v(" "),
                          _vm._t("after-price"),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row my-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [_vm._t("before-add-to-basket")],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 col-lg-8 offset-lg-4" },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "missing-order-properties":
                                        _vm.variationMissingProperties,
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation)
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.currentVariation.properties, function(
                                prop
                              ) {
                                return prop.property.id == 940
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-lg-8 offset-lg-4 my-3"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-primary btn-block",
                                            attrs: { type: "button" },
                                            on: {
                                              click: _vm.updateAndOpenModal
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Kostenlose Materialmuster anfordern\n                                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [_vm._t("after-add-to-basket")],
                                2
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.isWishListEnabled
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 text-right" },
                                  [
                                    _c("add-to-wish-list", {
                                      attrs: {
                                        "variation-id":
                                          _vm.currentVariation.variation.id
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("additional-content-after-add-to-basket"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-100 text-right d-none" },
                            [
                              _c(
                                "span",
                                { staticClass: "vat small text-muted" },
                                [
                                  _vm._v(
                                    "\n                                    * "
                                  ),
                                  _vm.showNetPrices
                                    ? [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemExclVAT"
                                              )
                                            )
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemInclVAT"
                                              )
                                            ) +
                                            "\n                                    "
                                        )
                                      ],
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemExclusive"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                  _vm.hasShippingCostsCategoryId
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            "data-toggle": "modal",
                                            href: "#shippingscosts",
                                            title: _vm.$translate(
                                              "Ceres::Template.singleItemShippingCosts"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemShippingCosts"
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          attrs: {
                                            title: _vm.$translate(
                                              "Ceres::Template.singleItemShippingCosts"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemShippingCosts"
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("additional-content-after-vat")
                        ],
                        2
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "my-5" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-tabs",
                          attrs: { role: "tablist" }
                        },
                        [
                          _vm.isDescriptionTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#details-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemDescription"
                                          )
                                        ) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTechnicalDataTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: {
                                      active:
                                        !_vm.isDescriptionTabActive &&
                                        _vm.isTechnicalDataTabActive
                                    },
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#data-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemTechnicalData"
                                          )
                                        ) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active:
                                    !_vm.isDescriptionTabActive &&
                                    !_vm.isTechnicalDataTabActive
                                },
                                attrs: {
                                  "data-toggle": "tab",
                                  href: "#assessments-details",
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemMoreDetails"
                                      )
                                    ) +
                                    "\n                                    "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._t("add-detail-tabs"),
                          _vm._v(" "),
                          _vm._m(2)
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tab-content overflow-hidden" },
                        [
                          _vm.isDescriptionTabActive
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane active",
                                  attrs: {
                                    id:
                                      "details-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tabpanel"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "my-4 item-description col-12 col-md-7",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.description
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._t("pattern"),
                                  _vm._v(" "),
                                  _vm._t("video")
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTechnicalDataTabActive
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive
                                  },
                                  attrs: {
                                    id:
                                      "data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tabpanel"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "my-4",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.technicalData
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane overflow-auto",
                              class: {
                                active:
                                  !_vm.isDescriptionTabActive &&
                                  !_vm.isTechnicalDataTabActive
                              },
                              attrs: {
                                id: "assessments-details",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c("div", { staticClass: "my-4" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-hover table-sm"
                                  },
                                  [
                                    _c("tbody", [
                                      _vm.itemConfig.includes("item.id") ||
                                      _vm.itemConfig.includes("all")
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemId"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item.id
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.item.condition &&
                                      _vm.currentVariation.item.condition.names
                                        .name !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.condition"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemCondition"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .condition.names.name
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.itemConfig.includes(
                                        "item.age_rating"
                                      ) || _vm.itemConfig.includes("all")
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemAge"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("ageRestriction")(
                                                    _vm.currentVariation.item
                                                      .ageRestriction
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation
                                        .externalId !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.external_id"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemExternalVariationId"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .externalId
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation.model !==
                                        "" &&
                                      (_vm.itemConfig.includes(
                                        "item.variation_model"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemModel"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .model
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.filter
                                        .hasManufacturer &&
                                      _vm.currentVariation.item.manufacturer
                                        .externalName !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.manufacturer"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemManufacturer"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .manufacturer.externalName
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.item
                                        .producingCountry &&
                                      _vm.currentVariation.item.producingCountry
                                        .names.name !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.producerCountry"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemManufacturingCountry"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .producingCountry.names.name
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.unit &&
                                      (_vm.itemConfig.includes(
                                        "item.variationBase_content"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemContent"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.unit
                                                    .content
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.currentVariation.unit
                                                      .names.name
                                                  )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation.weightG !==
                                        "" &&
                                      (_vm.itemConfig.includes(
                                        "item.weightG"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemWeight"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .weightG
                                                ) + " g"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation
                                        .weightNetG !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.weightNetG"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemNetWeight"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .weightNetG
                                                ) + " g"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.itemConfig.includes(
                                        "item.variation_dimensions"
                                      ) || _vm.itemConfig.includes("all")
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemDimensions"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.lengthMM
                                                  )
                                                )
                                              ]),
                                              _vm._v("×"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.widthMM
                                                  )
                                                )
                                              ]),
                                              _vm._v("×"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.heightMM
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                " mm\n                                                    "
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation
                                        .customsTariffNumber !== "" &&
                                      (_vm.itemConfig.includes(
                                        "variation.customs_tariff_number"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemCustomsTariffNumber"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .customsTariffNumber
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("add-detail-tabs-content")
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [_vm._t("cross-selling-similar")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [_vm._t("cross-selling-accessory")],
                  2
                ),
                _vm._v(" "),
                _vm._t("item-list-container"),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { id: "dewall-feedback" } },
                  [_vm._m(3), _vm._v(" "), _vm._t("feedback-container")],
                  2
                )
              ],
              2
            )
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 variation-select mt-5 mb-3 d-flex justify-content-between flex-column flex-lg-row"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "bg-grey d-flex justify-content-center justify-content-lg-start mb-3 px-3 py-1 align-items-center"
            },
            [
              _c("div", { staticClass: "single-feature-icon mr-3" }, [
                _c("i", {
                  staticClass: "fa fa-phone fa-2x",
                  attrs: { "aria-hidden": "true" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "single-feature-text" }, [
                _vm._v(
                  "\n                                        Persönlicher Kontakt"
                ),
                _c("br"),
                _c("a", { attrs: { href: "tel:+495232975570" } }, [
                  _vm._v(
                    "+49 (0) 5232 / 97 55 7\n                                        - 0"
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "bg-grey d-flex justify-content-center justify-content-lg-start mb-3 px-3 py-1 align-items-center"
            },
            [
              _c("div", { staticClass: "single-feature-icon mr-3" }, [
                _c("i", {
                  staticClass: "fa fa-tag fa-2x",
                  attrs: { "aria-hidden": "true" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "single-feature-text" }, [
                _vm._v(
                  "\n                                        3% Rabatt bei Vorkasse\n                                    "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "bg-grey d-flex justify-content-center justify-content-lg-start mb-3 px-3 py-1 align-items-center"
            },
            [
              _c("div", { staticClass: "single-feature-icon mr-3" }, [
                _c("i", {
                  staticClass: "fa fa-gift fa-2x",
                  attrs: { "aria-hidden": "true" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "single-feature-text" }, [
                _vm._v(
                  "\n                                        Kostenloser Versand\n                                    "
                )
              ])
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-right" }, [
      _c(
        "span",
        {
          staticClass: "badge badge-dark",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-html": "true",
            title:
              "Mehr Infos erhalten Sie, wenn Sie an der Kasse Ratenzahlung wählen!"
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-info",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" Infos zur Ratenzahlung\n                                ")
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: { id: "single-feedback", href: "#" }
        },
        [
          _vm._v(
            "\n                                        Bewertungen\n                                    "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback-tooltip" }, [
      _c("div", { staticClass: "info-icon" }, [_vm._v("i")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-text" }, [
        _vm._v("Information zur Echtheit der Bewertungen")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "feedback-tooltiptext" }, [
        _vm._v(
          "\n\t\t\t\t\t\t\tBewertungen, die den Status ‚verifizierter Kauf‘ haben, stammen von Kund:innen, die innerhalb unseres Shops mit Kundenkonto angemeldet den Artikel gekauft haben. Unser Bewertungssystem stellt sicher, dass nur Bewertungen, die diese Kriterien erfüllen, dieses Label erhalten. Bewertungen ohne dieses Label stammen entweder von Kund:innen, die anonym bewerten wollten, oder von freiwilligen Bewertungen des Artikels ohne Kaufbezug. Diese Bewertungen können von uns nicht hinsichtlich ihrer Echtheit überprüft werden.\n\t\t\t\t\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }